import isBicycle from '../../product/util/isBicycle';

const getMaxDisplayedQuantity = (sku: string) => {
    if (isBicycle(sku)) {
        return 10;
    }

    return 50;
};

export default getMaxDisplayedQuantity;
